import { createApiClient } from "Network/ApiClient";

export const PlanAxiosInstance = createApiClient("InsurancePlan/");
